var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _mask, _g, _mask2, _g2, _mask3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoText = function SvgLogoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 19,
    viewBox: "0 0 107 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.448 7.18273L28.9701 10.5086H31.9267L30.448 7.18273ZM32.3356 11.5271H28.5505L27.8913 12.9959H26.7025L29.8392 6.00391H31.0568L34.1935 12.9959H33.0056L32.3356 11.5271Z",
    fill: "#2D2C2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.815 12.9959H36.9335V6.00391H35.815V12.9959Z",
    fill: "#2D2C2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7566 12.9958H43.4563V6.00293H42.7566V12.9958Z",
    fill: "#2D2C2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9864 11.6771L50.946 9.35996V6.00439H51.6456V12.9964H51.226L46.7015 7.37239L46.7213 9.43926V12.9964H46.0216V6.00439H46.4611L50.9864 11.6771Z",
    fill: "#2D2C2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4672 13.1158C55.3636 13.1158 54.4103 12.7705 53.8799 12.3765V11.5479C54.4756 12.0593 55.4346 12.4269 56.4169 12.4269C57.4552 12.4269 58.3061 11.9568 58.3061 11.1076C58.4226 10.1403 56.8439 9.78258 55.9229 9.5298C54.3351 9.10271 54.0196 8.45341 54.0196 7.69258C54.0196 6.47823 55.1447 5.88428 56.4375 5.88428C57.276 5.88428 58.0021 6.07676 58.6151 6.46336V7.22254C57.9228 6.79049 57.2033 6.57323 56.4573 6.57323C55.2356 6.57323 54.7688 7.14323 54.7688 7.71241C54.6556 8.4501 55.7155 8.74254 56.3169 8.91106C57.6444 9.28858 59.0645 9.66197 59.0645 11.0985C59.0645 12.4451 57.7923 13.1158 56.4672 13.1158Z",
    fill: "#2D2C2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7046 6.00439V10.2695C66.7046 11.9497 65.6679 13.0658 63.9479 13.0658C62.2049 13.0658 61.1508 11.9415 61.1508 10.2695V6.00439H61.8505V10.2695C61.8505 11.6168 62.7766 12.4165 63.9479 12.4165C65.135 12.4165 66.0057 11.602 66.0057 10.2695V6.00439H66.7046Z",
    fill: "#2D2C2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9049 6.65287V9.75979H72.3022C73.4124 9.75979 73.9601 9.10718 73.9601 8.21666C73.9601 7.22287 73.3075 6.65287 72.3426 6.65287H69.9049ZM74.9399 12.9964H74.0303L71.7123 10.419H69.9049V12.9964H69.206V6.00439H72.3427C73.7941 6.00439 74.6598 6.94613 74.6598 8.22079C74.6598 9.44835 73.9139 10.2951 72.5517 10.3686L74.9399 12.9964Z",
    fill: "#2D2C2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1706 10.7283H81.6658L79.9178 6.75317L78.1706 10.7283ZM81.9458 11.3768H77.8906L77.1719 12.9959H76.4326L79.5684 6.00391H80.2681L83.4047 12.9959H82.6645L81.9458 11.3768Z",
    fill: "#2D2C2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1634 11.6771C90.1139 8.8197 90.123 10.0605 90.123 6.00439H90.8226V12.9964H90.403L85.8785 7.37239C85.9041 9.97539 85.8983 8.72883 85.8983 12.9964H85.1986V6.00439H85.6381L90.1634 11.6771Z",
    fill: "#2D2C2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1673 12.0466C98.4387 12.7744 97.5531 13.1056 96.6205 13.1056C94.333 13.1056 92.9849 11.6063 92.9849 9.54024C92.9849 7.4585 94.3545 5.90381 96.6205 5.90381C97.5259 5.90381 98.4693 6.22433 99.0971 6.96285L98.6683 7.39159C98.0835 6.82324 97.3673 6.55394 96.6205 6.55394C94.8138 6.55394 93.6837 7.84511 93.6837 9.53529C93.6837 11.2445 94.7461 12.4563 96.6205 12.4563C97.3656 12.4563 98.1479 12.1672 98.7179 11.598L99.1673 12.0466Z",
    fill: "#2D2C2E"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 6,
    width: 6,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.041 6.00439H106.055V12.9964H101.041V6.00439Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.055 12.9964H101.041V6.00439H105.965V6.65287H101.74V9.16996H105.775V9.81927H101.74V12.3463H106.055V12.9964Z",
    fill: "#2D2C2E"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H19.1167V18.9998H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1166 0H15.0225L-0.000701904 19H4.64273L15.1654 5.69256V5.72478C15.1654 5.72478 17.2976 4.55009 19.1166 3.57283V0Z",
    fill: "#714CC5"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 107,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19H106.055V0H0V19Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1653 18.9998H19.1165V5.72461H15.1653V18.9998Z",
    fill: "#714CC5"
  }))));
};
export default SvgLogoText;